import React, { Component } from "react";

export default class Privacy extends Component {
  render() {
    return (
      <div id="Privacy">
        <section className="Privacy" data-section="Privacy">
          <div className="col-md-12 text-center">
            <h1 className="heading">Privacy Notice</h1>
          </div>
          <div className="col-md-12">
            <p>
              Last updated April 1, 2024
            </p>
            <p>
              This privacy notice for Kien Tu (doing business as Double The Fun) 
              (“Company,” “we,” “us,” or “our“), describes how and why we might collect, store, use, and/or share (“process“) 
              your information when you use our services (“Services“), such as when you:
              <ul>
                <li>Visit our website at <em><a href="/">Double The Fun</a></em>, or any website of ours that links to this privacy notice</li>
                <li>[Download and use our application(s), such as our mobile application — Rumba, XXOO, UFit, or any other application of ours that links to this privacy notice]</li>
                <li>Engage with us in other related ways ― including any sales, marketing, or events</li>
              </ul>
            </p>
            <p><strong>Questions or concerns?</strong> Reading this privacy notice will help you understand your privacy rights and choices. 
              If you do not agree with our policies and practices, please do not use our Services. If you still have any questions or concerns, 
              please contact us at <em>doublethefun.contactus@gmail.com</em>.
            </p>
            <p>
              The terms used in this Privacy Policy have the same meanings as in
              our Terms and Conditions, which is accessible on this Site (<em><a href="/tos">Terms</a></em>).
            </p>
          </div>
          <div className="col-md-12">
            <h2 className="heading">Information Collection and Use</h2>
            <p>
              For a better experience while using our Service, we may require
              you to provide us with certain personally identifiable
              information, including but not limited to users name, location,
              pictures, and other identifiable data. The information that we
              request is retained on your device and on our servers.
            </p>
            <p>
              The apps do use third party services that may collect information
              used to identify you.
            </p>
          </div>
          <div className="col-md-12">
            <h2 className="heading">Log Data</h2>
            <p>
              We want to inform you that whenever you use our Service, in case
              of an error in the apps we collect data and information (through
              third party products) on your phone called Log Data. This Log Data
              may include information such as your devices’s Internet Protocol
              (“IP”) address, device name, operating system version,
              configuration of the apps when utilising our Service, the time and
              date of your use of the Service, and other statistics.
            </p>
          </div>
          <div className="col-md-12">
            <h2 className="heading">Service Providers</h2>
            <p>
              We may employ third-party companies and individuals due to the
              following reasons:
            </p>
            <ul>
              <li>To facilitate our Service;</li>
              <li>To provide the Service on our behalf;</li>
              <li>To perform Service-related services; or</li>
              <li>To assist us in analyzing how our Service is used.</li>
            </ul>
            <p>
              We want to inform users of this Service that these third parties
              have access to your Personal Information. The reason is to perform
              the tasks assigned to them on our behalf. However, they are
              obligated not to disclose or use the information for any other
              purpose.
            </p>
          </div>
          <div className="col-md-12">
            <h2 className="heading">Accounts and Security</h2>
            <p>
              We value your trust in providing us your Personal Information,
              thus we are striving to use commercially acceptable means of
              protecting it. But remember that no method of transmission over
              the internet, or method of electronic storage is 100% secure and
              reliable, and we cannot guarantee its absolute security.
            </p>
          </div>{" "}
          <div className="col-md-12">
            <h2 className="heading">Changes to This Privacy Policy</h2>
            <p>
              We may update our Privacy Policy from time to time. Thus, you are
              advised to review this page periodically for any changes. We will
              notify you of any changes by posting the new Privacy Policy on
              this page. These changes are effective immediately, after they are
              posted on this page.
            </p>
          </div>
        </section>
      </div>
    );
  }
}
